import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { TenantService } from './tenant.service';

/**
 * Guards the legacy `/start` route. If the tenant has opted into the new
 * stepper (`features.useNewStepper === true`), the user is redirected to
 * `/apply`. Otherwise the legacy page loads as before.
 *
 * Wait briefly for TenantService to finish loading on first paint.
 */
@Injectable({ providedIn: 'root' })
export class StartRedirectGuard implements CanActivate {
  constructor(private tenant: TenantService, private router: Router) {}

  async canActivate(): Promise<boolean | UrlTree> {
    const t = this.tenant.current ?? await this.tenant.waitReady();
    if (t?.features?.useNewStepper) {
      return this.router.parseUrl('/apply');
    }
    return true;
  }
}
